import localStorageIds from '../constants/localStorageIds'
import localStorageHelper from './localStorageHelper'
import SIDEBAR_OPTION from '../constants/sidebarOptions'

// eslint-disable-next-line no-unused-vars
const getSidebarConfig = ({ menuChoice, queryParams, hasOrgs }) => {
  // Profile items take highest priority
  if (SIDEBAR_OPTION.PROFILE_ITEMS.some((item) => item.name === menuChoice)) {
    return { sidebarKey: 'PROFILE_ITEMS', isProfileItems: true, isTeamSettings: false }
  }

  // Org settings take second priority
  if (SIDEBAR_OPTION.orgMenuChoices.some((item) => item.name === menuChoice)) {
    return { sidebarKey: 'orgMenuChoices', isProfileItems: false, isTeamSettings: true }
  }

  // Otherwise use the selected org's type
  const { localStorageValue: selectedOrg } = localStorageHelper(localStorageIds.SELECTED_ORG)
  const orgType = selectedOrg?.type ?? null

  return { sidebarKey: orgType, isProfileItems: false, isTeamSettings: false }
}

export default getSidebarConfig
